import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ToastService } from '../../../../shared/services/toast.service';
import { AuthService } from '../../../auth/services/auth.service';
import { navigateToRegisteredRoute } from '../../utils/route-navigation';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatToolbarModule, RouterLink],
  templateUrl: './toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  readonly user = inject(AuthService).user;
  readonly router = inject(Router);
  private readonly toastService = inject(ToastService);
  readonly isHome = this.router.url === '/dashboard';

  get profileImageUrl(): string {
    const prid = this.user()?.prid;

    const pathSegment = prid ? encodeURIComponent(prid) : '{prid}';
    return `https://adhoc.rd.astrazeneca.net/api/thumbs/${pathSegment}?appid=retire-right`;
  }

  isActive(path: string): boolean {
    const url = (this.router.url ?? '').split(/[?#]/)[0];
    return url === path || url.startsWith(`${path}/`);
  }

  navigateTo(path: string, label: string): Promise<void> {
    return navigateToRegisteredRoute(this.router, this.toastService, path, label);
  }
}
